export enum ETensionType {
    CLASSIC = 'Classic',
    FULL = 'Full',
    STACKED = 'Stacked'
}
